// @flow
import React from "react";
import styled from "styled-components";
import { connect, type MapStateToProps } from "react-redux";
import ProjectTitle from "../ProjectTitle";

import { fontSize } from "../common/styled-mixins";

import { withDeposit } from "../common/withDeposit";
import Gettext, { inferLocale } from "../common/Gettext";

import IronFooter from "../IndexPage/IronFooter";

import type { State as ServerData } from "../../redux/reducer/serverData";
import type { State as ReduxState } from "../../redux/reducer";
import withErrorCatch from "../withErrorCatch";

const FooterView = styled.footer`
  background: ##f5f5f5;
  padding: 50px 0 20px 0;
`;

const CenterContainer = styled.div`
  width: 940px;
  margin: 0 auto;
  position: relative;

  @media screen and (max-width: 960px) and (min-width: 800px) {
    width: 780px;
  }

  @media screen and (max-width: 799px) {
    width: 100%;
  }
`;

const Copyright = styled.div`
  direction: ${(props) => props.theme.direction};
  font-weight: 400;
  font-size: ${fontSize(14)};
  color: #919191;
  text-align: center;
`;

type Props = {
  className?: string,
  locale: string,
  serverData: ServerData,
  showDeposit: boolean,
};

type State = {
  selectedOption: string,
};

function getSupportInfo(serverData) {
  if (serverData == null || serverData.supportInfo === null) {
    return {};
  } else {
    return Object.keys(serverData.supportInfo)
      .filter((key) => key !== "en" && key !== "ru")
      .reduce((info, key) => {
        if (serverData != null) {
          info[key] = serverData.supportInfo[key];
        }

        return info;
      }, {});
  }
}

const DEFAULT_COUNTRY =
  process.env.REACT_APP_DEPLOY_TARGET === "siamoption" ? "th" : "vn";


class Footer extends React.Component<Props, State> {
  state = {
    selectedOption: "",
  };

  CurrentYear = () => {
    const date = new Date();
    return date.getFullYear();
  };

  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
  };

  componentDidMount() {
    const { serverData } = this.props;
    const supportInfo = getSupportInfo(serverData);

    const geo = serverData.geo.toLowerCase();

    let lang = null;
    switch (geo) {
      case "in":
        lang = "hi";
        break;
      default:
        lang = geo;
        break;
    }

    const geoPhone = supportInfo[lang] || supportInfo[DEFAULT_COUNTRY];
    if (geoPhone) {
      this.setState({
        selectedOption: {
          value: `${geo}`,
          label: `${geoPhone.phone[0]}`,
        },
      });
    }
  }

  render() {

    const { className } = this.props;
    const CurrentYear = this.CurrentYear;

    // prettier-ignore
    return (
      <FooterView className={className}>
        <CenterContainer>
          <Copyright>
            &copy; <CurrentYear /> <ProjectTitle />.{" "}
            <Gettext>All rights reserved</Gettext>.
          </Copyright>
        </CenterContainer>
      </FooterView>
    );
  }
}

const mapStateToProps = (state: ReduxState) => ({
  serverData: state.serverData,
  isMobileApp:
    (state.serverData &&
      (state.serverData.isIOS || state.serverData.isAndroidApp)) ||
    false,
  locale: inferLocale(state),
  profile: state.profile,
});

export default withErrorCatch(
  connect((mapStateToProps: MapStateToProps<*, *, *>))(
    withDeposit((props) => {
      return process.env.REACT_APP_DEPLOY_TARGET === "irontrade" ? (
        props.isMobileApp ? (
            <IronFooter {...props} />
        ) : (
          <IronFooter {...props} />
        )
      ) : (
        <Footer {...props} />
      );
    })
  )
);



// WEBPACK FOOTER //
// ./src/components/StaticPage/Footer.js